<div class="common-engagement-grid">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="data()"></grid-content>
</div>